module.exports = __webpack_public_path__ + "static/media/banner.cb825e75.jpg";